import React, { Component, useRef } from 'react';
import * as FeatherIcon from 'react-feather';
import { useSpring, animated } from 'react-spring';
import logo from 'images/logoNoBackground.png';
import botLogo from 'images/chatLogo.png';
import chatLogo from 'images/KK_image.jpg';
import './index.css';
import _cloneDeep from 'lodash/cloneDeep';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { getChatBotResponse } from '../../../service/infinitetableproperties/action';
import RaiseTicket from './RaiseTicket';

const Footer = () => {
    const messagesEndRef = useRef(null);

    const [showChat, setShowChat] = React.useState(false);
    const [qus, setQus] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isMaximized, setIsMaximized] = React.useState(false);
    const [chatType, setChatType] = React.useState('');
    const defaultMessage = [
        { message: 'Hello User!!', isUser: false },
        { message: 'Hi There!!', isUser: true },
    ];
    const [messages, setMessages] = React.useState([]);
    const chatTypes = (type) => {
        setChatType(type);
        const msg = {
            message: type === 'BlocData' ? 'How may I help you?' : 'Click here to enter your issue description',
            isUser: false,
            isRaiseTicket: type !== 'BlocData',
        };
        // messages.push(msg);
        setMessages([msg]);
    };
    const chatSpring = useSpring({
        transform: showChat ? 'translateX(0%)' : 'translateX(101%)',
    });

    React.useEffect(() => {
        chatTypes('BlocData');
    }, []);

    const toggleChat = () => {
        setQus('');
        setShowChat(!showChat);
        if (!showChat) {
            chatTypes('BlocData');
        }
        // setMessages([]);
        // let radio = document.getElementsByName('chatType');
        // radio.forEach((itm) => (itm.checked = false));
    };
    const sendChat = async () => {
        if (chatType === 'BlocData') {
            const request = { message: qus, isUser: true };
            messages.push(request);
            setQus('');
            const { data } = await getChatBotResponse(qus);
            const { answer } = data.data;
            const response = { message: answer, isUser: false };
            messages.push(response);
            setMessages(messages);
        }
        setLoading(false);
    };

    React.useEffect(() => {
        if (messagesEndRef) {
            messagesEndRef.current.addEventListener('DOMNodeInserted', (event) => {
                const { currentTarget: target } = event;
                target.scroll({ top: target.scrollHeight, behavior: 'smooth' });
            });
        }
    }, [messages]);

    const showDescription = (result) => {
        const answers = [
            {
                message: `Issue Title: ${result['issue_title']}`,
                isUser: false,
            },
            {
                message: `Jira ID: ${result['jira_id']}`,
                isUser: false,
            },
            {
                message: `Email Response: ${result['email_response']}`,
                isUser: false,
            },
        ];
        messages.push(...answers);
        setMessages(_cloneDeep(messages));
    };

    return (
        <footer className="footer">
            <div className="container-fluid">
                <div className="row">
                    <div>
                        <div class="div-img">
                            {/* <FeatherIcon.MessageCircle fill='#4BB3BC'  /> */}
                            <img onClick={toggleChat} className="enlarge" src={botLogo} />
                        </div>
                        {/* <button style={{ borderRadius: 30 }} >
                        </button> */}
                        <animated.div
                            className={isMaximized ? 'chat-container-max mb-1 mr-1' : 'chat-container mb-1 mr-1'}
                            style={chatSpring}
                        >
                            {/* Chat content goes here */}
                            <div className="chat-header">
                                <div className="d-flex w-100">
                                    <Label>Vincilium</Label>
                                    {isMaximized ? (
                                        <FeatherIcon.Minimize2
                                            style={{ cursor: 'pointer' }}
                                            className="mt-2 mr-3 icon-xs ml-auto"
                                            onClick={() => setIsMaximized(!isMaximized)}
                                        />
                                    ) : (
                                        <FeatherIcon.Maximize2
                                            style={{ cursor: 'pointer' }}
                                            className="mt-2 mr-3 icon-xs ml-auto"
                                            onClick={() => setIsMaximized(!isMaximized)}
                                        />
                                    )}
                                    <FeatherIcon.X style={{ cursor: 'pointer' }} className="mt-2 icon-xs " onClick={() => toggleChat()} />
                                </div>
                            </div>
                            <div
                                className="chat-body"
                                ref={messagesEndRef}
                                style={{ height: isMaximized ? '85%' : '75%', overflowX: 'hidden', overflowY: 'auto' }}
                            >
                                {defaultMessage.map((item, idx) => (
                                    <>
                                        <div className={item.isUser ? 'float-right font-weight-bold' : 'float-left w-100'} key={idx}>
                                            {!item.isUser && <img src={chatLogo} height={15} className="mr-2 mb-1" alt="" />}
                                            {item.message}
                                        </div>
                                        <br />
                                    </>
                                ))}
                                <FormGroup className="d-flex w-100 m-2">
                                    <div className="mx-3 w-100" style={{ position: 'sticky' }}>
                                        <Input
                                            className="mt-2"
                                            name="chatType"
                                            checked={chatType === 'BlocData'}
                                            onClick={() => chatTypes('BlocData')}
                                            type="radio"
                                        />
                                        <Label>Bloc Data</Label>
                                    </div>
                                    <div className="mx-3 w-100" style={{ position: 'sticky' }}>
                                        <Input className="mt-2" name="chatType" onClick={() => chatTypes('RaiseTicket')} type="radio" />
                                        <Label>Raise Ticket</Label>
                                    </div>
                                </FormGroup>
                                {messages.map((data, index) => (
                                    <>
                                        <div
                                            className={data.isUser ? 'float-right my-1 mt-3 font-weight-bold' : 'float-left w-100 my-1'}
                                            key={index}
                                        >
                                            {!data.isUser && <img src={chatLogo} height={15} className="mr-2 mb-0 mt-1" alt="" />}
                                            {data.isRaiseTicket ? (
                                                <a href="javascript:void(0)" onClick={() => setIsModalOpen(!isModalOpen)}>
                                                    {data.message}
                                                </a>
                                            ) : (
                                                <div style={{ marginLeft: 25, marginTop: '-20px' }}>
                                                    {data.message && data.message.split('\n').map((itm) => <div>{itm}</div>)}
                                                </div>
                                            )}
                                        </div>
                                        <br />
                                    </>
                                ))}
                            </div>
                            <Form>
                                <div className="w-100" style={{ position: 'absolute', bottom: 2, left: 2 }}>
                                    {loading && (
                                        <div class="typing mb-3 ml-2">
                                            <span className="typingDot"></span>
                                            <span className="typingDot"></span>
                                            <span className="typingDot"></span>
                                        </div>
                                    )}
                                    <div className="d-flex w-100">
                                        <Input
                                            placeholder="How can I help you ?"
                                            value={qus}
                                            type="text"
                                            onChange={({ target: { value } }) => setQus(value)}
                                        />
                                        <button
                                            type="submit"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setLoading(true);
                                                sendChat();
                                            }}
                                        >
                                            <FeatherIcon.Send className="icon-dual icon-md m-1" />
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </animated.div>
                    </div>
                </div>
                {isModalOpen && (
                    <RaiseTicket
                        isModalOpen={isModalOpen}
                        updateModal={() => setIsModalOpen(!isModalOpen)}
                        setMessages={(result) => showDescription(result)}
                    />
                )}
            </div>
        </footer>
    );
};

export default Footer;
